import { render, staticRenderFns } from "./User.vue?vue&type=template&id=3be3653f&"
import script from "./User.vue?vue&type=script&lang=ts&"
export * from "./User.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports